import r from "./generateUtilityClasses.mjs";
import a from "./generateUtilityClass.mjs";
function t(e) {
  return a("MuiDialog", e);
}
const i = r("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]);
export {
  i as default,
  t as getDialogUtilityClass
};
//# sourceMappingURL=dialogClasses.mjs.map
